/* global angular */
( function () {
	'use strict';
	/* eslint no-ternary:0 */

	// @ngInject
	function apiService ( $http, $location, $resource, $q, _, edivateBaseUrl ) {
		function observation () {
			return $resource( '/api/v1/users/:userId/:observation/:observationId/:children', {
				'userId'        : '@userId',
				'observation'   : '@observation',
				'observationId' : '@observationId',
				'children'      : '@children'
			}, {
				'update' : {
					'method' : 'PUT'
				}
			} );
		}

		// Scheduled Observations
		// PUT /v1/events/{eventId} Update an existing observation.
		// POST /v1/events Schedule a new observation.
		// GET /api/v1/users/{userId}/events Get a list of scheduled observations.
		function userEvents () {
			return $resource( '/api/v1/users/:userId/events', {
				'userId' : '@userId'
			}, {
				'update' : {
					'method' : 'PUT'
				}
			} );
		}

		// User Lookup
		// GET /api/v1/users/{userId} Gets a specific user.
		function userInfo () {
			return $resource( '/api/v1/users/:userId', { 'userId' : '@userId' } );
		}

		function events () {
			return $resource( '/api/v1/events/:eventId', {
				'eventId' : '@eventId'
			}, {
				'update' : {
					'method' : 'PUT'
				}
			} );
		}

		// Scheduled Observation Email Notifications
		// POST /v1/notifications/email/scheduled-observations Email notification to Observee
		function schedObsEmailNotif () {
			return $resource( '/api/v1/notifications/email/scheduled-observations' );
		}

		// GET /v1/users/{userId}/status/{observation}/{observationId} Get the status of an observation.
		// GET /v1/users/{userId}/status/{observations} Get the status of an observation.

		// @observation: 'observation' or 'observations'
		function obsStatus () {
			return $resource( '/api/v1/users/:userId/:observations/:observationId', {
				'userId'        : '@userId',
				'observations'  : '@observations',
				'observationId' : '@observationId'
			} );
		}

		// POST /v1/users/{userId}/template Create a new template.
		// PUT /v1/users/{userId}/template This will update an existing template
		// GET /v1/users/{userId}/template/{templateId} Get a user's template.
		// POST /v1/users/{userId}/template/{templateId}/library Add a template to the user's template library.
		//  DELETE /v1/users/{userId}/template/{templateId}/library Remove a template from the user's template library.
		//
		// @library: 'library'
		//
		// Usage:
		// Get a template
		// apiService.template
		//     .get( {
		//          'userId' : '13778',
		//          'templateId' : '8175a279-adb9-4ff0-a407-382e261d6f9f'
		//     } )
		function template () {
			return $resource( '/api/v1/users/:userId/templates/:templateId', {
				'userId'     : '@userId',
				'templateId' : '@templateId'
			} );
		}

		// GET /v1/users/{userId}/templates Description goes here
		// GET /v1/users/{userId}/templates/library Get the templates in a user's template library.
		// GET /v1/users/{userId}/templates/list Get the template names and their ids for a user.
		//
		// @list: 'list' or 'library'
		//
		// Usage:
		// Get templates list
		// apiService.templates
		//     .query( {
		//         'userId' : '13778'
		//     } )
		//     .$promise.then( function ( resource ) {
		//         console.log( resource );
		//     } );
		function templates () {
			return $resource( '/api/v1/users/:userId/templates', {
				'userId' : '@userId'
			}, {
				'update' : {
					'method' : 'PUT'
				}
			} );
		}

		// GET /v1/user/templates/{templateId}/draft Get the template draft
		// PUT /v1/user/templates/{templateId}/draft Update template draft
		// Usage:
		// Get template draft
		// apiService.templateDraft
		//     .query( {
		//         'templateId' : 'ccde4613-e666-43ae-b736-89af950890b3'
		//     } )
		//     .$promise.then( function ( resource ) {
		//         console.log( resource );
		//     } );
		function templateDraft () {
			return $resource( '/api/v1/user/templates/:templateId/draft', {
				'templateId' : '@templateId'
			}, {
				'update' : {
					'method' : 'PUT'
				},

				'get' : {
					'method'      : 'GET',
					'customError' : function () {}
				}
			} );
		}

		// Usage:
		// Delete template
		// apiService.deleteTemplate
		//     .remove( {
		//         'templateId' : '1234556'
		//     } )
		//     .$promise.then( function ( resource ) {
		//         console.log( resource );
		//     } );
		function deleteTemplate () {
			return $resource( '/api/v1/templates/:templateId', {
				'templateId' : '@templateId'
			} );
		}

		// Usage:
		// Find revisions given a templateId
		function getRevisions () {
			return $resource( '/api/v1/user/templates/:templateId/revisions', {
				'templateId' : '@templateId'
			} );
		}

		// GET /v1/legacy/hierarchy/:clientId/users Return a user list for a given ClientId
		// Usage:
		// Get user list based on rights
		//
		// @clientId : personnelId
		// @rights   : 'create' or 'view'
		//
		// apiService.users
		// 	.get( {
		// 		'clientId' : '396466',
		// 		'rights'   : 'create'
		// 	} )
		// 	.$promise.then( function ( resource ) {
		// 		console.log( resource );
		// 	} );
		function users () {
			return $resource( '/api/v1/users/:userId/privilege/observe/:rights/observations', {
				'userId' : '@id',
				'rights' : '@rights'
			} );
		}

		function allUsersAtLocation () {
			return $resource( '/api/v1/legacy/hierarchy/:locationId/users', {
				'locationId' : '@locationId'
			}, {
				'query' : {
					'method'  : 'GET',
					'isArray' : false
				}
			} );
		}

		// GET /api/v1/users/{userId}/permissions Get user's permissions.
		// apiService.getUserPermissions
		// 	.get( {
		// 		'userId' : '396466'
		// 	} )
		// 	.$promise.then( function ( resource ) {
		// 		console.log( resource );
		// 	} );
		function getUserPermissions () {
			return $resource( '/api/v1/users/:userId/permissions/observe/template', {
				'userId' : '@userId'
			} );
		}

		function tokenSessions () {
			return $resource( '/api/v1/sessions/:bearerToken', {
				'bearerToken' : '@bearerToken'
			} );
		}

		// POST /api/v1/legacy/authenticate  Return a session token  and  user info
		// Usage:
		// apiService.user
		// .save( {
		// 	'loginName' : 'testfoo',
		// 	'password'  : 'testfoo'
		// } ).$promise.then( function ( resource ) {
		// 	console.log( resource );
		// } );
		function user () {
			return $resource( '/api/v1/legacy/authenticate' );
		}

		// GET /api/v1/legacy/users/:userId/licenses
		function getUserLicenses () {
			return $resource( '/api/v1/legacy/users/:userId/licenses', {
				'userId' : '@userId'
			} );
		}

		function doEtlProcess ( userId ) {
			return $http.get( '/api/v1/reports/jaspersoft/users/' + userId );
		}

		// POST /api/v1/reports/jaspersoft/tokens  Return a session token  and  user info
		function jasperAuthenticate () {
			return $http.post( '/api/v1/reports/jaspersoft/tokens' );
		}

		function getCompletedObservationsByObsView () {
			return $resource( '/api/v1/users/:userId/observations?abbrev=false&limit=10000', {
				'userId' : '@userId'
			} );
		}

		function getCompletedObservationsByObsViewAndRevision () {
			return $resource( '/api/v1/users/:userId/observations?abbrev=false&limit=10000&revision=:revision', {
				'userId'   : '@userId',
				'revision' : '@revision'
			} );
		}

		function getObservationsByUser () {
			return $resource( '/api/v1/users/:userId/observations', {
				'userId' : '@userId'
			} );
		}

		function getTemplatesForReports () {
			return $resource( '/api/v1/observe-reports/user/templates' );
		}

		function getHierarchyForReports () {
			return $resource( '/api/v1/observe-reports/observations/hierarchy' );
		}

		function getObservationExport () {
			return function ( theTemplateId ) {
				return $http.get( '/api/v1/user/export/observe/templates/' + theTemplateId + '/observations?format=csv' );
			};
		}

		function edivateLibrary () {
			return $resource( edivateBaseUrl + '/api/v3/search', {
				'q'          : '@q',
				'categories' : '@categories',
				'start'      : '@start',
				'rows'       : '@rows'
			}, {
				'query' : {
					'method' : 'GET'
				}
			} );
		}

		function getDetails () {
			return $resource( '/api/v1/legacy/users/:userId/content', {
				'userId' : '@userId'
			}, {
				'save' : {
					'method'  : 'POST',
					'isArray' : true
				}
			} );
		}

		function getContentDetails () {
			return $resource( '/api/v1/legacy/users/:userId/content/:contentId', {
				'userId'    : '@userId',
				'contentId' : '@contentId'
			}, {
				'query' : {
					'method' : 'GET'
				}
			} );
		}

		/**
		 * Add to template library / favorites
		 * Delete template from template library / favorites
		 * /v1/users/{userId}/template/{templateId}/library
		 */
		function templateLibrary () {
			return $resource( '/api/v1/users/:userId/templates/:templateId/library', {
				'userId'     : '@userId',
				'templateId' : '@templateId'
			} );
		}

		/**
		 * gets list of library/fave
		 * /v1/users/:userId/templates/library
		 */
		function library () {
			return $resource( '/api/v1/users/:userId/templates/library', {
				'userId' : '@userId'
			} );
		}

		/**
		 * get eula
		 * /v1/legacy/eula
		 */
		function getEula () {
			return $resource( '/api/v1/legacy/eula' );
		}

		/**
		 * post eula
		 * /v1/users/{userId}/eula
		 */
		function postEula ( userId ) {
			return $resource( '/api/v1/users/' + userId + '/eula', {
				'initials' : '@initials'
			}, {
				'save' : {
					'method' : 'POST'
				}
			} );
		}

		function observationTypes () {
			return $resource( '/api/v1/observe/config/observationTypes' );
		}

		function copyTemplate () {
			return $resource( '/api/v1/users/:userId/templates/:templateId/copy/:recipientId', {
				'userId'      : '@userId',
				'templateId'  : '@templateId',
				'recipientId' : '@recipientId'
			} );
		}

		// this is getting observations for reports
		function getObservationReport () {
			return $resource( '/api/v1/users/:userId/observations', {
				'userId' : '@userId'
			} );
		}

		function getUserReports () {
			return $resource( '/api/v1/users/:userId/reports',
				{
					'userId' : '@userId'
				}, {
					'query' : {
						'method'  : 'GET',
						'isArray' : true
					}
				} );
		}

		//  Get all hierarchy based, viewable in-progress observations for a user.
		function getInProgressObsReports () {
			return $resource( '/api/v1/observe-reports/user/hierarchy/in-progress-observations',
				{
					'userId' : '@userId'
				}, {
					'query' : {
						'method'  : 'GET',
						'isArray' : true
					}
				} );
		}

		function getPrebuiltReports () {
			return $resource( '/api/v1/reports/prebuilt',
				{ }, {
					'query' : {
						'method'  : 'GET',
						'isArray' : true
					}
				} );
		}

		function setFavoriteReport () {
			return $resource( '/api/v1/reports/users/:userId/:reportId/favorite', {
				'userId'   : '@userId',
				'reportId' : '@reportId'
			}, {
				'save' : {
					'method' : 'POST'
				}
			} );
		}

		function deleteFavorite () {
			return $resource( '/api/v1/reports/users/:userId/:reportId/favorite', {
				'userId'   : '@userId',
				'reportId' : '@reportId'
			}, {
				'delete' : {
					'method' : 'DELETE'
				}
			} );
		}

		function deleteCustomReport () {
			return $resource( '/api/v1/reports/:reportId/users/:userId/custom', {
				'userId'   : '@userId',
				'reportId' : '@reportId'
			}, {
				'update' : {
					'method'  : 'DELETE',
					'isArray' : true
				}
			} );
		}

		function updateDateGenerated () {
			return $resource( '/api/v1/reports/:reportId/user/date-generated', {
				'reportId' : '@reportId'
			}, {
				'update' : {
					'method' : 'PUT'
				}
			} );
		}

		function requestCustomReport () {
			return $resource( '/api/v1/reports/request-report' );
		}

		function getAllCustomReport () {
			return $resource( '/api/v1/reports', {}, {
				'query' : {
					'method'  : 'GET',
					'isArray' : true
				}
			} );
		}

		function generateUUID () {
			/* globals uuid */
			// Use uuid.v4() from node-uuid package
			return uuid.v4();
		}

		function templatesPrivilege () {
			return $resource( '/api/v1/:type/:id/privileges/observe/templates/:templateId', {
				'type'       : '@type',
				'id'         : '@id',
				'templateId' : '@templateId'
			}, {
				'update' : {
					'method' : 'PUT'
				}
			} );
		}

		function templatesPermission () {
			return $resource( '/api/v1/users/:userId/templates/permissions', {
				'userId' : '@userId'
			} );
		}

		function templatePrivilege () {
			return $resource( '/api/v1/:type/:id/permissions/observe/templates/:templateId', {
				'type'       : '@type',
				'id'         : '@id',
				'templateId' : '@templateId'
			}, {
				'update' : {
					'method' : 'PUT'
				}
			} );
		}

		function deleteObservation () {
			return $resource( '/api/v1/observations/:observationId', {
				'observationId' : '@observationId'
			} );
		}

		// GET /api/v1/hierarchy/{hierarchyId}     Returns the hierarchy
		// GET /api/v1/hierarchy/{clientId}/schools     Get all schools per client
		// GET /api/v1/hierarchy/{hierarchyId}/district     Returns the district information for a given hierarchyId
		// GET /api/v1/hierarchy/{id}/users    Return a user list for a given ClientId

		// @type: 'district', 'schools' or 'users'
		function getHierarchy () {
			return $resource( '/api/v1/hierarchy/:id/:type', {
				'id'   : '@id',
				'type' : '@type'
			} );
		}

		// This is for Template Preview
		function getObsScore () {
			return $resource( '/api/v1/observation/score' );
		}

		// get, update delete user observation view privilege
		function obsViewPrivilege () {
			return $resource( '/api/v1/users/:userId/privileges/observe/observations/:observationId/view', {
				'userId'        : '@userId',
				'observationId' : '@observationId'
			}, {
				'update' : {
					'method' : 'PUT'
				}
			} );
		}

		// get file by fileId, delete by fileId
		function file ( fileId, config ) {
			config.url = '/api/v1/files/' + fileId;

			return $http( config );
		}

		// download a file
		function fileDownload ( fileId, config ) {
			config.url = '/api/v1/files/' + fileId +  '/download';

			return $http( config );
		}

		// get observation file format whitelist
		function obsAllowedFileFormats () {
			return $resource( '/api/v1/observe/config/allowed-file-formats', { }, {
				'query' : {
					'method'  : 'GET',
					'isArray' : true
				}
			} );
		}

		// get all files by resource id
		function filesByResourceId () {
			return $resource( '/api/v1/files/resources/:resourceId', {
				'resourceId' : '@resourceId'
			}, {
				'query' : {
					'method'  : 'GET',
					'isArray' : true
				}
			} );
		}

		function getFeedback ( obsId ) {
			var url = '/api/v1/observation/' + obsId + '/feedback';

			return $http.get( url );
		}

		function getPost ( obsId, feedbackId ) {
			var url = [
				'/api/v1/observation/',
				obsId,
				'/feedback/',
				feedbackId,
				'/posts'
			].join( '' );

			return $http.get( url );
		}

		function userDetails ( userId ) {
			var url = '/api/v1/users/' + userId;

			return $http.get( url );
		}

		function getUsersThatCanProvideFeedback ( observationId ) {
			return $http.get( '/api/v1/privileges/user/observe/observation/' + observationId + '/view/users' );
		}

		function getMC ( id ) {
			var additionalParams = [ '/' + id, '' ];

			var url = edivateBaseUrl + '/api/v1/microcredentials' + additionalParams[ Number( !id ) ];

			return $http.get( url );
		}

		function updateSignature ( id, sig ) {
			var url = '/api/v1/users/observations/' + id + '/signature';

			return $http.patch( url, sig );
		}

		function getObservation ( userId, obsId ) {
			var url = '/api/v1/users/' + userId + '/observations/' + obsId;

			return $http.get( url );
		}

		function getInReviewLocations () {
			var url = '/api/v1/user/privilege/observe/share';

			return $http.get( url );
		}

		var service = {
			'observation'                                  : observation(),
			'userEvents'                                   : userEvents(),
			'events'                                       : events(),
			'schedObsEmailNotif'                           : schedObsEmailNotif(),
			'obsStatus'                                    : obsStatus(),
			'template'                                     : template(),
			'library'                                      : library(),
			'templates'                                    : templates(),
			'templateDraft'                                : templateDraft(),
			'users'                                        : users(),
			'allUsersAtLocation'                           : allUsersAtLocation(),
			'user'                                         : user(),
			'userInfo'                                     : userInfo(),
			'jasperAuthenticate'                           : jasperAuthenticate,
			'doEtlProcess'                                 : doEtlProcess,
			'getCompletedObservationsByObsView'            : getCompletedObservationsByObsView(),
			'getCompletedObservationsByObsViewAndRevision' : getCompletedObservationsByObsViewAndRevision(),
			'getRevisions'                                 : getRevisions(),
			'getObservationsByUser'                        : getObservationsByUser(),
			'getTemplatesForReports'                       : getTemplatesForReports(),
			'getHierarchyForReports'                       : getHierarchyForReports(),
			'getObservationExport'                         : getObservationExport(),
			'generateUUID'                                 : generateUUID,
			'edivateLibrary'                               : edivateLibrary(),
			'templateLibrary'                              : templateLibrary(),
			'observationTypes'                             : observationTypes(),
			'getDetails'                                   : getDetails(),
			'getContentDetails'                            : getContentDetails(),
			'copyTemplate'                                 : copyTemplate(),
			'tokenSessions'                                : tokenSessions(),
			'templatePrivilege'                            : templatePrivilege(),
			'templatesPrivilege'                           : templatesPrivilege(),
			'templatesPermission'                          : templatesPermission(),
			'getUserPermissions'                           : getUserPermissions(),
			'getEula'                                      : getEula(),
			'postEula'                                     : postEula,
			'deleteTemplate'                               : deleteTemplate(),
			'getUserLicenses'                              : getUserLicenses(),
			'deleteObservation'                            : deleteObservation(),
			'getHierarchy'                                 : getHierarchy(),
			'getObservationReport'                         : getObservationReport(),
			'getObsScore'                                  : getObsScore(),
			'getInProgressObsReports'                      : getInProgressObsReports(),
			'getPrebuiltReports'                           : getPrebuiltReports(),
			'getUserReports'                               : getUserReports(),
			'setFavoriteReport'                            : setFavoriteReport(),
			'deleteFavorite'                               : deleteFavorite(),
			'deleteCustomReport'                           : deleteCustomReport(),
			'updateDateGenerated'                          : updateDateGenerated(),
			'requestCustomReport'                          : requestCustomReport(),
			'getAllCustomReport'                           : getAllCustomReport(),
			'obsViewPrivilege'                             : obsViewPrivilege(),
			'file'                                         : file,
			'fileDownload'                                 : fileDownload,
			'obsAllowedFileFormats'                        : obsAllowedFileFormats(),
			'filesByResourceId'                            : filesByResourceId(),
			'userDetails'                                  : userDetails,
			'getUsersThatCanProvideFeedback'               : getUsersThatCanProvideFeedback,
			'mc'                                           : { 'get' : getMC },
			'signature'                                    : { 'update' : updateSignature },
			'getInReviewLocations'                         : getInReviewLocations,

			'obs' : {
				'get' : getObservation
			},

			'feedback' : {
				'get'   : getFeedback,
				'posts' : {
					'get' : getPost
				}
			}
		};

		return service;
	}

	angular
	.module( 'app.core' )
	.factory( 'apiService', apiService );
} )( );
